// LoginModal.js
import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import './LoginModal.css';

export default function LoginModal({
                                       visible,
                                       onClose,
                                       onSwitchToRegister,
                                       onGoogleSuccess,
                                   }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    if (!visible) return null; // не рендеримо, якщо невидимий

    const handleSubmit = async (e) => {
        e.preventDefault();

        const res = await fetch('https://5x5gu5f6ojvf4qvvmfg7wmysfu0vfdhq.lambda-url.eu-west-2.on.aws/auth', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                action: 'login',
                email: email,
                password: password
            })
        });

        if (!res.ok) {
            throw new Error(`Error: ${res.status}`);
        }
        const data = await res.json();
        console.log(data);

        setEmail('');
        setPassword('');

        // Запис кукі
        document.cookie = `userData=${JSON.stringify({
            firstname: data.firstname, 
            email: data.email,
            token: data.token
        })}; path=/`;

        // Закриття модалки
        window.location.reload();
    };

    return (
        <div className="login-modal-backdrop">
            <div className="login-modal-content">
                <button className="login-close-btn" onClick={onClose}>
                    &times;
                </button>
                <h2 className="login-title">Login</h2>
                <form className="login-form" onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        className="login-input"
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        className="login-input"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button type="submit" className="login-submit-btn">
                        Login
                    </button>
                    <div className="google-section">
                        <GoogleLogin
                            onSuccess={(credentialResponse) => {
                                console.log('Google ID token:', credentialResponse.credential);
                                onGoogleSuccess(credentialResponse.credential);
                            }}
                            onError={() => {
                                console.error('Google Login Failed');
                            }}
                        />
                    </div>
                </form>

                <p className="login-switch-text">
                    Not registered yet?
                    <button className="switch-to-register-btn" onClick={onSwitchToRegister}>
                        Register
                    </button>
                </p>


            </div>
        </div>
    );
}
